<template>
  <v-app id="searchHuis">
    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="10">
            <v-row dense class="mt-2">
              <v-col cols="3">
                <v-text-field v-model="huis_code" label="Acco ID" hint="Search values beginning with...(searches plannings, current code and old code if any)" @keyup.enter="getAccos" class="pr-4"></v-text-field>
              </v-col>
              <v-col cols="3">
                <select_bedr_codes :selected_bedrcodes="bedrCodesSelected" field="bedrCodesSelected" :isClearable="true"
                  @updateData="updateData" :localStorageItem="localStorageItemBedr" class="pr-4"></select_bedr_codes>
              </v-col>
              <v-col cols="6">
                <select_status_codes :selected_statcodes="statCodesSelected" field="statCodesSelected"
                  :isClearable="true" @updateData="updateData" :localStorageItem="localStorageItemStat" :visibleChips="14" class="pr-4">
                </select_status_codes>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3">
                <v-text-field v-model="huis_naam" label="Accommodation name" hint="Use of wildcards (*<input>*) supported" autocomplete="new-acco-name" @keyup.enter="getAccos" dense
                  class="pr-4"></v-text-field>
              </v-col>
              <v-col cols="3" class="pr-4">
                <v-select v-model="plts_nr" :items="plts_nrKeuzesFiltered" item-value="plts_nr" item-text="plts_naam"
                  label="City" dense clearable>
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field v-model="searchCityInput" placeholder="Search"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="pr-4">
                <v-text-field v-model="eign_naam" label="Host name" hint="Use of wildcards (*<input>*) supported" autocomplete="new-host-name" @keyup.enter="getAccos" dense></v-text-field>
              </v-col>
              <v-col cols="3" class="pr-4">
                <v-text-field v-model="eign_email" label="Host email" hint="Use of wildcards (*<input>*) supported" autocomplete="new-host-email" @keyup.enter="getAccos" dense></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="pr-4">
                <v-text-field v-model="partner_acco_id" label="Acco ID at Sales partner" @keyup.enter="getAccos"
                  dense></v-text-field>
              </v-col>
              <v-col cols="3" class="pr-4">
                <v-text-field v-model="eign_tel" label="Host telephone" hint="Use of wildcards (*<input>*) supported" autocomplete="new-host-telephone" @keyup.enter="getAccos" dense></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" class="pr-4">
                  <m_select_gebr_codes label="Rental expert(s)" field="gebrCodesSelected" @updateData="updateData"
                    :selected_gebrcodes="gebrCodesSelected"  :localStorageItem="localStorageItemGebr"
                    :canSelectAll="true" :isClearable="true" :isSearchable="true" :isMultiple="true" :isDense="false"
                    :visibleChips="8" />                  
              </v-col>
              <v-col cols="2">
                <v-btn class="primary" style="margin-top: 20px;" small @click="getAccos"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
                <v-btn class="warning ml-2" style="margin-top: 20px;" small @click="clearSearch"><v-icon left>mdi-refresh</v-icon>Clear</v-btn>
              </v-col>
              <v-col cols="2" style="margin-top: 15px;">
                <div v-if="items.length > 0"><b>Found {{ items.length }} accommodations</b></div>
                <div v-if="items.length > 0" style="font-size: x-small;">{{ searchTime }}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="results" no-gutters>
          <v-col cols="12">
            <acco_table :items="items" :fixedHeader="false" :loading="loading"/>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <standard_dialog ref="standard_dialog"  @standard_dialog_close="closeDialog()" />
    <navBar title="Ares - Main menu" :home="true" :accolist="true" type="main" />
  </v-app>
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";
import acco_table from '@/components/huis/tables/searchHuisTable.vue';
import select_status_codes from "@/components/ui/selectors/select_status_codes.vue"
import select_bedr_codes from "@/components/ui/selectors/select_bedr_codes.vue"
import m_select_gebr_codes from "@/components/ui/selectors/m_select_gebr.vue"
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {
  components: {
    navBar,
    acco_table,
    select_status_codes,
    select_bedr_codes,
    m_select_gebr_codes,
    standard_dialog
  },
  data() {
    return {
      localStorageItemStat: 'search.acco.statcodes',
      localStorageItemBedr: 'search.acco.bedrcodes',
      localStorageItemGebr: 'search.acco.gebrcodes',
      results: false,
      statCodesSelected: [],
      plts_nrKeuzes: [],
      plts_nr: '',
      gebrCodesSelected: [],
      bedrCodesSelected: [],
      items: [],
      huis_code: '',
      huis_naam: '',
      eign_naam: '',
      eign_tel: '',
      eign_email: '',
      partner_acco_id: '',
      searchCityInput: '',
      searchTime: ''
    }
  },
  computed: {
    plts_nrKeuzesFiltered() {
      let cities = this.plts_nrKeuzes
      if (this.searchCityInput) {
        cities = cities.filter(x => {
          return x.plts_naam.toLowerCase().indexOf(this.searchCityInput.toLowerCase()) > -1;
        })
      }
      return cities
    }
  },
  created() {
    this.$axios
      .post("ares/json/ares/huis/getSearchHuisPlts.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSearchHuisParam"
        },
        getSearchHuisParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          this.plts_nrKeuzes = res.data.getSearchHuisParam.plts_nrKeuzes
        }
      });

  },  
  methods: {
    updateData(data) {
      this[data.field] = data.value;
    },
    closeDialog() {
      this.items=[]         
      this.searchTime=''
      this.results=false
    },
    clearSearch() {
      // Clear only text fields and results, keep select fields intact
      this.huis_code = '';
      this.huis_naam = '';
      this.eign_naam = '';
      this.eign_tel = '';
      this.eign_email = '';
      this.partner_acco_id = '';
      this.plts_nr = '';
      this.searchCityInput = '';
      this.items = [];
      this.searchTime = '';
      this.results = false;
    },
    getAccos() {
      this.items=[]
      this.loading = true
      this.$axios
        .post("ares/json/ares/huis/searchHuis.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHuis"
          },
          searchHuis: {
            huis_code: this.huis_code,
            statusses: this.statCodesSelected,
            bedr_codes: this.bedrCodesSelected,
            gebr_codes: this.gebrCodesSelected,
            huis_naam: this.huis_naam,
            plts_nr: this.plts_nr,
            partner_acco_id: this.partner_acco_id,
            eign_email: this.eign_email,
            eign_naam: this.eign_naam,
            eign_tel: this.eign_tel
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.$refs.standard_dialog.setWidth(450);
            this.$refs.standard_dialog.setTextClass("text-center text-body-1 pa-3 pt-6");
            this.$refs.standard_dialog.open('warning', 'Warning', res.data.error.message);   
            this.loading = false;
          } else {                      
            localStorage.setItem(this.localStorageItemStat, this.statCodesSelected);
            localStorage.setItem(this.localStorageItemBedr, this.bedrCodesSelected);
            localStorage.setItem(this.localStorageItemGebr, this.gebrCodesSelected);
            this.items = res.data.searchHuis;
            this.searchTime = res.data.elapsedTime.text
            this.results = true
            this.loading = false;
          }
        })
    },
  }
};
</script>
